/**
 * Pricing item type values
 */
export enum PricingItemTypeEnum {
	STANDARD = 'standard',
	EXTRA = 'extra',
}
